import React from "react";
import PropTypes from "prop-types";
// Constants
import * as FORM_CONST from "../../../constants/formComponents";
// Styles
import "./InputDate.css";
import classNames from "classnames";

const InputDate = ({
  className = "",
  disabled = false,
  label,
  onChange,
  placeholder = FORM_CONST.PLACEHOLDER_INPUT_DATE,
  required = false,
  style,
  value,
  wrapperClassName,
  ...additionalProps
}) => {
  const labelClasses = classNames("input__date-label", {
    "admin__disabled-color": disabled,
  });

  const inputDateClasses = classNames(
    "input__date",
    {
      "admin__disabled-color admin__disabled-background user__disabled-background":
        disabled,
    },
    {
      "input__date-default": !className,
    }
  );

  return (
    <div className={wrapperClassName}>
      {label && (
        <label className={labelClasses}>
          {label}
          {required ? "*" : null}
        </label>
      )}
      <input
        className={inputDateClasses}
        disabled={disabled}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        style={style}
        type="date"
        value={value}
        {...additionalProps}
      />
    </div>
  );
};

InputDate.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  style: PropTypes.object,
  value: PropTypes.string,
  wrapperClassName: PropTypes.string,
};

export default InputDate;
